<template>
    <q-card style="min-width: 90%;">
        <q-card-section class="q-pa-none">
            <div class="q-pa-lg">
                <div class="text-h5 q-mb-lg">Narrative Reports</div>
                <div v-if="loadingReports">
                    <q-spinner />
                    <span class="q-ml-sm">Loading reports...</span>
                </div>
                <div v-else class="reports-container">
                    <div v-if="reports.length === 0" class="text-center q-pa-lg text-grey-6">
                        No narrative reports available
                    </div>
                    <q-expansion-item
                        v-for="report in reports"
                        :key="report.id"
                        class="report-card"
                        expand-icon-class="text-primary"
                    >
                        <template v-slot:header>
                            <q-item-section>
                                <div class="report-title">{{ report.title }}</div>
                                <div class="subtitle2 text-grey-6">{{report.assistant}}</div>
                            </q-item-section>
                            <q-item-section side>
                                <div class="report-meta">{{ formatDate(report.created_at) }}</div>
                            </q-item-section>
                        </template>

                        <q-card>
                            <q-card-section class="report-content">
                                <p v-for="(paragraph, index) in formatContent(report.content)" :key="index">
                                    {{ paragraph }}
                                </p>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>
                </div>
            </div>
        </q-card-section>
    </q-card>
</template>

<script>
import notify from '@/services/util/notify';
import api from '../../services/api/api';

export default {
    name: "NarrativeReportsComponent",

    props: {
        clientId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            reports: [],  // To store the list of reports
            loadingReports: false,  // To manage loading state
            columns: [
                { name: 'title', label: 'Title', align: 'left', field: 'title', sortable: true },
                { name: 'assistant', label: 'Type', align: 'center', field: 'assistant', sortable: true },
                { name: 'createdAt', label: 'Created At', align: 'center', field: 'created_at', sortable: true },
            ],
            expandedReports: {}
        };
    },

    async created() {
        await this.fetchReports();
    },

methods: {
        async fetchReports() {
            this.loadingReports = true;
            try {
                const response = await api.reports.previousNarrativeReport(this.clientId);
                this.reports = response.data;
            } catch (error) {
                console.error("Error fetching narrative reports:", error);
                notify.error("Error fetching narrative reports")
            } finally {
                this.loadingReports = false;
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString('en-NZ', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formatContent(content) {
            if (!content) return [];
            
            if (content.includes('\n\n')) {
                return content.split('\n\n').filter(p => p.trim());
            }
            
            const sentences = content.match(/[^.!?]+[.!?]+/g) || [content];
            const paragraphs = [];
            for (let i = 0; i < sentences.length; i += 3) {
                paragraphs.push(sentences.slice(i, i + 3).join(' ').trim());
            }
            return paragraphs;
        }
    }
};
</script>

<style scoped>
.report-card {
    background: white;
    border-radius: 8px;
    margin-bottom: 24px;
    border: 1px solid #e0e0e0;
    overflow: hidden;
}

.report-card >>> .q-expansion-item__container {
    border: none;
}

.report-card >>> .q-item {
    padding: 24px 32px;
}

.report-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
}

.report-meta {
    font-size: 13px;
    color: #666;
}

.report-content {
    font-size: 15px;
    line-height: 1.8;
    color: #333;
    padding: 24px 32px 32px 32px !important;
    background: #fafafa;
}

.report-content p {
    margin-bottom: 16px;
}

.report-content p:last-child {
    margin-bottom: 0;
}
</style>